import React from 'react';
import { useTranslation } from '@shared/core';

/** Read by screen readers, hidden on screen. */
const visuallyHidden: React.CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  margin: -1,
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
};

/**
 * A registration field's label. Required fields carry no mark; an optional one ends in a quieter
 * "optional", without a separator, as survey questions do. The marker inherits the label's colour, so
 * it follows the page's text colour on a matched page. Screen readers hear it in parentheses, "Mobile
 * phone (optional)", so it reads as a note on the label rather than part of it.
 */
export const RegistrationFieldLabel: React.FC<Readonly<{ text: string; isOptional?: boolean }>> = ({ text, isOptional }) => {
  const { tq } = useTranslation('eventFormDisplay');
  return (
    <>
      {text}
      {isOptional && (
        <>
          <span
            aria-hidden
            style={{ fontWeight: 400, opacity: 0.72 }}
          >
            {' '}
            {tq`optional`}
          </span>
          <span style={visuallyHidden}> {tq`(optional)`}</span>
        </>
      )}
    </>
  );
};
